const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class EmployeeGroupServiceConnector {
  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async createEmployeeGroup(options = {}) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/employee-groups`,
        method: 'POST',
        ...options,
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async updateEmployeeGroup(employeeGroup) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/employee-groups/${employeeGroup.id}`,
        method: 'PUT',
        data: {
          name: employeeGroup.name,
          description: employeeGroup.description,
          restrictionId: employeeGroup.restrictionId,
        },
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async deleteEmployeeGroup(id) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/employee-groups/${id}`,
        method: 'DELETE',
      };
      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async updateEmployeeGroupEmployees({ employeeGroupId, requestParams }) {
    try {

      const request = {
        url: `/${CURRENT_VERSION}/employee-groups/${employeeGroupId}/employees`,
        method: 'PATCH',
        data: requestParams,
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  /**
   *
   * @param sort
   * @param page
   * @param maxPerPage
   * @param employeeId
   * @param dynamicSearch
   * @param restrictionId
   * @param corporationId
   * @param type
   * @returns {Promise<void|{headers: any, data: any}>}
   */
  async listEmployeeGroups({ sort, page = 0, maxPerPage = 10, employeeId, dynamicSearch, ids, restrictionId, corporationId, type }) {
    try {
      const params = { sort, page, maxPerPage, dynamicSearch, type, employeeId, ids };

      if (restrictionId) {
        params.restrictionId = restrictionId;
      }
      if (corporationId) {
        params.corporationId = corporationId;
      }

      const { data, headers } = await this.httpClient.get(`/${CURRENT_VERSION}/employee-groups`, {
        params,
      });
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getEmployeeGroup(id) {
    try {
      const { data, headers } = await this.httpClient.get(`/${CURRENT_VERSION}/employee-groups/${id}`);
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  EmployeeGroupServiceConnector,
};
